import PropTypes from 'prop-types';

import { MARKET_DATA } from 'context/MarketInfo/marketConfig';

export const marketInfoPropType = PropTypes.exact({
  market: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  phonePrefix: PropTypes.string,
  mastheadDirOverride: PropTypes.string,
}).isRequired;

const marketFiltersPropTypes = {
  markets: PropTypes.arrayOf(PropTypes.string),
  excluded_markets: PropTypes.arrayOf(PropTypes.string),
};

const formFieldBasePropType = {
  ...marketFiltersPropTypes,
  name: PropTypes.string,
  type: PropTypes.oneOf(['text', 'textarea', 'select', 'phone', 'email', 'radio', 'banner']),
  placeholder: PropTypes.bool,
  placeholderOverride: PropTypes.string,
  help_text: PropTypes.bool,
  maxlength: PropTypes.number,
  required: PropTypes.bool,
  required_with: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
  label: PropTypes.string,
  labelOverride: PropTypes.string,
  title: PropTypes.string,
  content: PropTypes.string,
  autoComplete: PropTypes.string,
};

// Override match logic allows only a certain set of keys - either markets or the few custom cases
const ALLOWED_MATCH_KEYS = Object.keys(MARKET_DATA)
  .map(market => `market:${market}`)
  .concat(['phone_market']);

const overrideMatchPropType = (array, key, componentName) => {
  if (!ALLOWED_MATCH_KEYS.includes(array[key])) {
    return new Error(`Invalid value (${array[key]}) for override match, supplied to ${componentName}`);
  }
  return true;
};

export const baseFieldFieldPropType = PropTypes.exact({
  ...formFieldBasePropType,
  overrides: PropTypes.arrayOf(
    PropTypes.exact({
      match_all: PropTypes.arrayOf(overrideMatchPropType),
      match_any: PropTypes.arrayOf(overrideMatchPropType),
      data: PropTypes.exact(formFieldBasePropType).isRequired,
    }),
  ),
}).isRequired;

export const contentLegalReportingFieldPropType = PropTypes.exact({
  ...marketFiltersPropTypes,
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['text', 'textarea', 'select', 'email', 'radio', 'checkbox']).isRequired,
  hasDefaultPlaceholder: PropTypes.bool,
  help_text: PropTypes.bool,
  maxlength: PropTypes.number,
  required: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.string),
  label: PropTypes.string,
}).isRequired;
